'use client';

import { observer } from 'mobx-react-lite';
import { GlobalStoreType } from '@fshr/stores';
import LoadingIndicator from '../loading-indicator';
import { ItineraryBody } from './ItineraryBody';

/**
 * globalStore: Mobx Global Store used to save common data
 * translations: Function used to translate static strings
 * locale: Page language
 * upcomingTripsUrlRedirection: URL used on all stays button, if set redirects the user to that URL, if not just close the itinerary layout
 */
export type ItineraryComponentProps = {
	globalStore?: GlobalStoreType;
	locale?: string;
	urlPath?: string;
	closeComponent?: () => void;
};

export const ItineraryComponent = observer(function (props: ItineraryComponentProps) {
	const { globalStore } = props;

	// If no active booking Id show loading indicator
	if (globalStore?.fetching) {
		return (
			<div className="w-full">
				<LoadingIndicator />
			</div>
		);
	}

	return (
		<div
			className="w-full md:w-[540px]"
			role="tabpanel"
			tabIndex={0}
			aria-labelledby="itinerary-tab"
			id="itinerary-section"
		>
			<ItineraryBody {...props} />
		</div>
	);
});
